import { Injectable } from '@angular/core';
import { cloneDeep } from 'lodash-es';
import { BehaviorSubject } from 'rxjs';

import { FlowchartNodeDto } from '@treetop/shared/model';

@Injectable()
export class FlowchartElementsSubjectStore {
  public flowchartElementsSubject = new BehaviorSubject<FlowchartNodeDto[]>([]);

  public getValue(): FlowchartNodeDto[] {
    return this.flowchartElementsSubject.getValue() ?? [];
  }

  public next(value: FlowchartNodeDto[]): void {
    this.flowchartElementsSubject.next(value);
  }

  public getCloneDeepValue(): FlowchartNodeDto[] {
    return cloneDeep(this.getValue());
  }
}
